import React, { useState, useEffect, useCallback, useRef } from 'react';

// ── CONSTANTS ──────────────────────────────────────────────────────────────
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API = `${BASE}/api/law`;
const getHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

// ── BRAND COLORS ───────────────────────────────────────────────────────────
const C = {
  navy: '#00206E',
  orange: '#FF8400',
  navyLight: '#eff6ff',
  orangeLight: '#fff7ed',
};

// ── INPUT CLASS ────────────────────────────────────────────────────────────
const ic = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-[#00206E] bg-white";
const ta = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:outline-none focus:border-[#00206E] bg-white resize-none";

// ── ICONS ──────────────────────────────────────────────────────────────────
const Icons = {
  act: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>,
  chapter: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  section: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>,
  rule: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
  schedule: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  circular: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  search: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  add: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  edit: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>,
  delete: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>,
  back: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>,
  close: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  bookmark: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>,
  eye: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
  kebab: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>,
  law: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>,
  amendment: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>,
  penalty: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  tip: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
  publish: <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 6 9 17 4 12"/></svg>,
};

// ── STATUS BADGE ────────────────────────────────────────────────────────────
function Badge({ label, color = C.navy, bg = C.navyLight, border }) {
  return (
    <span style={{
      padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600,
      background: bg, color, border: `1px solid ${border || color + '30'}`,
    }}>
      {label}
    </span>
  );
}

// ── SECTION READER VIEW ─────────────────────────────────────────────────────
function SectionReader({ section, onClose, onEdit }) {
  const subSections = Array.isArray(section.sub_sections) ? section.sub_sections : [];
  const relatedForms = Array.isArray(section.related_forms) ? section.related_forms : [];
  const keywords = Array.isArray(section.keywords) ? section.keywords : [];

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{
        background: 'white', borderRadius: 20, width: '100%', maxWidth: 820,
        maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px', borderBottom: '1px solid #e2e8f0',
          background: `linear-gradient(135deg, ${C.navyLight}, ${C.orangeLight})`,
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <span style={{
                  padding: '2px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700,
                  background: C.navy, color: 'white',
                }}>
                  Section {section.section_number}
                </span>
                {section.is_amended && (
                  <span style={{
                    padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                    background: '#fff7ed', color: C.orange, border: `1px solid ${C.orange}30`,
                  }}>
                    Amended
                  </span>
                )}
                {!section.is_published && (
                  <span style={{
                    padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600,
                    background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
                  }}>
                    Draft
                  </span>
                )}
              </div>
              <h2 style={{ fontSize: 18, fontWeight: 800, color: C.navy, lineHeight: 1.3 }}>
                {section.section_title}
              </h2>
              {section.chapter_title && (
                <p style={{ fontSize: 12, color: '#64748b', marginTop: 4 }}>
                  {section.chapter_number && `Chapter ${section.chapter_number} — `}{section.chapter_title}
                </p>
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
              {onEdit && (
                <button onClick={onEdit} style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '7px 14px', borderRadius: 10,
                  border: `1px solid ${C.navy}`, background: 'white',
                  color: C.navy, fontSize: 12, fontWeight: 600, cursor: 'pointer',
                }}>
                  {Icons.edit} Edit
                </button>
              )}
              <button onClick={onClose} style={{
                width: 32, height: 32, borderRadius: 10, border: '1px solid #e2e8f0',
                background: 'white', color: '#64748b', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {Icons.close}
              </button>
            </div>
          </div>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '24px' }}>

          {/* Main Text */}
          {section.section_text && (
            <div style={{ marginBottom: 24 }}>
              <p style={{
                fontSize: 14, lineHeight: 1.9, color: '#1e293b',
                whiteSpace: 'pre-wrap', fontFamily: '"Plus Jakarta Sans", sans-serif',
              }}>
                {section.section_text}
              </p>
            </div>
          )}

          {/* Sub-sections */}
          {subSections.length > 0 && (
            <div style={{ marginBottom: 24 }}>
              {subSections.map((sub, idx) => (
                <div key={idx} style={{
                  marginBottom: 16,
                  borderLeft: sub.type === 'proviso' ? `3px solid ${C.orange}` :
                               sub.type === 'explanation' ? '3px solid #7c3aed' :
                               `3px solid ${C.navy}`,
                  paddingLeft: 16,
                }}>
                  <div style={{ display: 'flex', gap: 10 }}>
                    {sub.number && (
                      <span style={{
                        fontSize: 13, fontWeight: 700, color: C.navy,
                        flexShrink: 0, minWidth: 40,
                      }}>
                        {sub.number}
                      </span>
                    )}
                    <p style={{
                      fontSize: 13, lineHeight: 1.8, color: '#334155',
                      whiteSpace: 'pre-wrap', fontFamily: '"Plus Jakarta Sans", sans-serif',
                      fontStyle: sub.type === 'proviso' ? 'italic' : 'normal',
                    }}>
                      {sub.text}
                    </p>
                  </div>
                  {sub.type === 'proviso' && (
                    <span style={{
                      fontSize: 10, fontWeight: 700, color: C.orange,
                      textTransform: 'uppercase', letterSpacing: 1,
                    }}>
                      Proviso
                    </span>
                  )}
                  {sub.type === 'explanation' && (
                    <span style={{
                      fontSize: 10, fontWeight: 700, color: '#7c3aed',
                      textTransform: 'uppercase', letterSpacing: 1,
                    }}>
                      Explanation
                    </span>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Info Grid */}
          <div style={{
            display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 16, marginBottom: 24,
          }}>

            {/* Related Forms */}
            {relatedForms.length > 0 && (
              <div style={{
                background: C.navyLight, borderRadius: 14, padding: 16,
                border: `1px solid ${C.navy}20`,
              }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: C.navy, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
                  📋 Related Forms
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {relatedForms.map((f, i) => (
                    <span key={i} style={{
                      padding: '4px 10px', borderRadius: 8,
                      background: C.navy, color: 'white',
                      fontSize: 12, fontWeight: 600,
                    }}>
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Due Date */}
            {section.due_date_logic && (
              <div style={{
                background: '#ecfdf5', borderRadius: 14, padding: 16,
                border: '1px solid #a7f3d020',
              }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: '#059669', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                  ⏰ Due Date
                </p>
                <p style={{ fontSize: 13, color: '#064e3b', fontWeight: 600 }}>
                  {section.due_date_logic}
                </p>
                {section.due_date_days && (
                  <p style={{ fontSize: 12, color: '#059669', marginTop: 4 }}>
                    {section.due_date_days} days
                  </p>
                )}
              </div>
            )}

            {/* Penalty */}
            {(section.penalty_provision || section.penalty_amount) && (
              <div style={{
                background: '#fef2f2', borderRadius: 14, padding: 16,
                border: '1px solid #fecaca',
              }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: '#dc2626', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                  ⚠️ Penalty
                </p>
                {section.penalty_amount && (
                  <p style={{ fontSize: 14, fontWeight: 700, color: '#dc2626' }}>
                    {section.penalty_amount}
                  </p>
                )}
                {section.penalty_provision && (
                  <p style={{ fontSize: 12, color: '#7f1d1d', marginTop: 4 }}>
                    {section.penalty_provision}
                  </p>
                )}
                {section.penalty_section && (
                  <p style={{ fontSize: 11, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                    Ref: {section.penalty_section}
                  </p>
                )}
              </div>
            )}

            {/* Amendment */}
            {section.is_amended && (
              <div style={{
                background: '#fff7ed', borderRadius: 14, padding: 16,
                border: `1px solid ${C.orange}30`,
              }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: C.orange, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                  📝 Amendment
                </p>
                {section.amended_by && (
                  <p style={{ fontSize: 12, color: '#92400e', fontWeight: 600 }}>
                    {section.amended_by}
                  </p>
                )}
                {section.amendment_date && (
                  <p style={{ fontSize: 12, color: C.orange }}>
                    {new Date(section.amendment_date).toLocaleDateString('en-IN')}
                  </p>
                )}
                {section.amendment_notes && (
                  <p style={{ fontSize: 12, color: '#78350f', marginTop: 6 }}>
                    {section.amendment_notes}
                  </p>
                )}
              </div>
            )}
          </div>

          {/* CA Practical Notes */}
          {section.practical_notes && (
            <div style={{
              background: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)',
              borderRadius: 14, padding: 16, marginBottom: 16,
              border: '1px solid #bae6fd',
            }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: '#0369a1', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                💡 CA Practical Notes
              </p>
              <p style={{ fontSize: 13, color: '#0c4a6e', lineHeight: 1.7 }}>
                {section.practical_notes}
              </p>
            </div>
          )}

          {/* CA Tips */}
          {section.ca_tips && (
            <div style={{
              background: '#f0fdf4', borderRadius: 14, padding: 16, marginBottom: 16,
              border: '1px solid #bbf7d0',
            }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: '#15803d', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                ✅ CA Tips
              </p>
              <p style={{ fontSize: 13, color: '#14532d', lineHeight: 1.7 }}>
                {section.ca_tips}
              </p>
            </div>
          )}

          {/* Common Mistakes */}
          {section.common_mistakes && (
            <div style={{
              background: '#fff7ed', borderRadius: 14, padding: 16, marginBottom: 16,
              border: `1px solid ${C.orange}30`,
            }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: C.orange, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
                ❌ Common Mistakes
              </p>
              <p style={{ fontSize: 13, color: '#92400e', lineHeight: 1.7 }}>
                {section.common_mistakes}
              </p>
            </div>
          )}

          {/* Keywords */}
          {keywords.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <p style={{ fontSize: 11, fontWeight: 600, color: '#94a3b8', marginBottom: 8 }}>Keywords:</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                {keywords.map((k, i) => (
                  <span key={i} style={{
                    padding: '3px 10px', borderRadius: 20, fontSize: 11,
                    background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0',
                  }}>
                    {k}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ── SECTION FORM ────────────────────────────────────────────────────────────
function SectionForm({ actId, chapters, section, onSave, onClose }) {
  const isEdit = !!section;
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    chapter_id: section?.chapter_id || '',
    section_number: section?.section_number || '',
    section_title: section?.section_title || '',
    section_text: section?.section_text || '',
    sub_sections: Array.isArray(section?.sub_sections) ? section.sub_sections : [],
    related_forms: Array.isArray(section?.related_forms) ? section.related_forms.join(', ') : '',
    related_rules: Array.isArray(section?.related_rules) ? section.related_rules.join(', ') : '',
    related_sections: Array.isArray(section?.related_sections) ? section.related_sections.join(', ') : '',
    due_date_logic: section?.due_date_logic || '',
    due_date_days: section?.due_date_days || '',
    penalty_provision: section?.penalty_provision || '',
    penalty_amount: section?.penalty_amount || '',
    penalty_section: section?.penalty_section || '',
    practical_notes: section?.practical_notes || '',
    ca_tips: section?.ca_tips || '',
    common_mistakes: section?.common_mistakes || '',
    keywords: Array.isArray(section?.keywords) ? section.keywords.join(', ') : '',
    is_amended: section?.is_amended || false,
    amended_by: section?.amended_by || '',
    amendment_date: section?.amendment_date ? String(section.amendment_date).slice(0, 10) : '',
    amendment_notes: section?.amendment_notes || '',
    original_text: section?.original_text || '',
    is_active: section?.is_active !== false,
    is_published: section?.is_published || false,
    effective_date: section?.effective_date ? String(section.effective_date).slice(0, 10) : '',
    display_order: section?.display_order || '',
  });

  const addSubSection = () => {
    setForm(f => ({
      ...f,
      sub_sections: [...f.sub_sections, { number: '', text: '', type: 'sub-section' }],
    }));
  };

  const updateSubSection = (idx, field, val) => {
    setForm(f => ({
      ...f,
      sub_sections: f.sub_sections.map((s, i) => i === idx ? { ...s, [field]: val } : s),
    }));
  };

  const removeSubSection = (idx) => {
    setForm(f => ({ ...f, sub_sections: f.sub_sections.filter((_, i) => i !== idx) }));
  };

  const handleSave = async () => {
    if (!form.section_number || !form.section_title) {
      alert('Section number and title are required');
      return;
    }
    setSaving(true);
    try {
      const payload = {
        ...form,
        related_forms: form.related_forms.split(',').map(s => s.trim()).filter(Boolean),
        related_rules: form.related_rules.split(',').map(s => s.trim()).filter(Boolean),
        related_sections: form.related_sections.split(',').map(s => s.trim()).filter(Boolean),
        keywords: form.keywords.split(',').map(s => s.trim()).filter(Boolean),
        chapter_id: form.chapter_id || null,
      };

      const url = isEdit
        ? `${API}/acts/${actId}/sections/${section.id}`
        : `${API}/acts/${actId}/sections`;

      const res = await fetch(url, {
        method: isEdit ? 'PUT' : 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message || 'Could not save'); return; }
      onSave(data);
    } catch (e) {
      alert('Server error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
      zIndex: 1000, display: 'flex', alignItems: 'flex-start',
      justifyContent: 'center', padding: '20px', overflowY: 'auto',
    }}>
      <div style={{
        background: 'white', borderRadius: 20, width: '100%', maxWidth: 900,
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)', marginBottom: 20,
      }}>
        {/* Header */}
        <div style={{
          padding: '20px 24px', borderBottom: '1px solid #e2e8f0',
          background: `linear-gradient(135deg, ${C.navyLight}, ${C.orangeLight})`,
          borderRadius: '20px 20px 0 0',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 38, height: 38, borderRadius: 12,
              background: C.navy, display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: 'white',
            }}>
              {Icons.section}
            </div>
            <div>
              <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>
                {isEdit ? 'Edit Section' : 'Add New Section'}
              </p>
              <p style={{ fontSize: 12, color: '#64748b' }}>
                Fill all statutory details for this section
              </p>
            </div>
          </div>
          <button onClick={onClose} style={{
            width: 32, height: 32, borderRadius: 10, border: '1px solid #e2e8f0',
            background: 'white', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b',
          }}>
            {Icons.close}
          </button>
        </div>

        <div style={{ padding: 24 }}>

          {/* ─ IDENTITY ─ */}
          <div style={{ marginBottom: 28 }}>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 14 }}>
              Section Identity
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Chapter
                </label>
                <select value={form.chapter_id} onChange={e => setForm(f => ({ ...f, chapter_id: e.target.value }))} className={ic}>
                  <option value="">No Chapter</option>
                  {chapters.map(c => (
                    <option key={c.id} value={c.id}>
                      Ch. {c.chapter_number} — {c.chapter_title.slice(0, 30)}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Section Number *
                </label>
                <input
                  value={form.section_number}
                  onChange={e => setForm(f => ({ ...f, section_number: e.target.value }))}
                  placeholder="e.g. 168"
                  className={ic}
                />
              </div>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Section Title *
                </label>
                <input
                  value={form.section_title}
                  onChange={e => setForm(f => ({ ...f, section_title: e.target.value }))}
                  placeholder="e.g. Resignation of Director"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Display Order
                </label>
                <input
                  type="number"
                  value={form.display_order}
                  onChange={e => setForm(f => ({ ...f, display_order: e.target.value }))}
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Effective Date
                </label>
                <input
                  type="date"
                  value={form.effective_date}
                  onChange={e => setForm(f => ({ ...f, effective_date: e.target.value }))}
                  className={ic}
                />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 24 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#475569', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={form.is_published}
                    onChange={e => setForm(f => ({ ...f, is_published: e.target.checked }))}
                  />
                  Published
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#475569', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={form.is_active}
                    onChange={e => setForm(f => ({ ...f, is_active: e.target.checked }))}
                  />
                  Active
                </label>
              </div>
            </div>
          </div>

          {/* ─ SECTION TEXT ─ */}
          <div style={{ marginBottom: 28 }}>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 14 }}>
              Section Text
            </p>
            <textarea
              rows={6}
              value={form.section_text}
              onChange={e => setForm(f => ({ ...f, section_text: e.target.value }))}
              placeholder="Enter the main section text here..."
              className={ta}
            />
          </div>

          {/* ─ SUB-SECTIONS ─ */}
          <div style={{ marginBottom: 28 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5 }}>
                Sub-Sections, Provisos & Explanations
              </p>
              <button
                type="button"
                onClick={addSubSection}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '6px 14px', borderRadius: 10,
                  background: C.navy, color: 'white',
                  border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                }}
              >
                {Icons.add} Add
              </button>
            </div>

            {form.sub_sections.length === 0 ? (
              <div style={{
                padding: 20, borderRadius: 14, border: '1px dashed #e2e8f0',
                textAlign: 'center', color: '#94a3b8', fontSize: 13,
              }}>
                No sub-sections added. Click "Add" to add sub-sections, provisos or explanations.
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {form.sub_sections.map((sub, idx) => (
                  <div key={idx} style={{
                    background: '#f8fafc', borderRadius: 14, padding: 14,
                    border: '1px solid #e2e8f0',
                  }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr 140px 40px', gap: 10, marginBottom: 10 }}>
                      <div>
                        <label style={{ display: 'block', fontSize: 11, fontWeight: 500, color: '#64748b', marginBottom: 4 }}>Number</label>
                        <input
                          value={sub.number}
                          onChange={e => updateSubSection(idx, 'number', e.target.value)}
                          placeholder="(1)"
                          className={ic}
                          style={{ fontSize: 12 }}
                        />
                      </div>
                      <div>
                        <label style={{ display: 'block', fontSize: 11, fontWeight: 500, color: '#64748b', marginBottom: 4 }}>Type</label>
                        <select
                          value={sub.type}
                          onChange={e => updateSubSection(idx, 'type', e.target.value)}
                          className={ic}
                          style={{ fontSize: 12 }}
                        >
                          <option value="sub-section">Sub-Section</option>
                          <option value="proviso">Proviso</option>
                          <option value="explanation">Explanation</option>
                          <option value="exception">Exception</option>
                        </select>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button
                          type="button"
                          onClick={() => removeSubSection(idx)}
                          style={{
                            width: 32, height: 32, borderRadius: 8,
                            background: '#fef2f2', border: '1px solid #fecaca',
                            color: '#dc2626', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                          }}
                        >
                          {Icons.delete}
                        </button>
                      </div>
                    </div>
                    <div>
                      <label style={{ display: 'block', fontSize: 11, fontWeight: 500, color: '#64748b', marginBottom: 4 }}>Text</label>
                      <textarea
                        rows={3}
                        value={sub.text}
                        onChange={e => updateSubSection(idx, 'text', e.target.value)}
                        placeholder="Sub-section text..."
                        className={ta}
                        style={{ fontSize: 12 }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* ─ COMPLIANCE INFO ─ */}
          <div style={{ marginBottom: 28 }}>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 14 }}>
              Compliance Information
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Related Forms (comma separated)
                </label>
                <input
                  value={form.related_forms}
                  onChange={e => setForm(f => ({ ...f, related_forms: e.target.value }))}
                  placeholder="DIR-12, DIR-11, MGT-14"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Related Rules (comma separated)
                </label>
                <input
                  value={form.related_rules}
                  onChange={e => setForm(f => ({ ...f, related_rules: e.target.value }))}
                  placeholder="Rule 15, Rule 16"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Due Date Logic
                </label>
                <input
                  value={form.due_date_logic}
                  onChange={e => setForm(f => ({ ...f, due_date_logic: e.target.value }))}
                  placeholder="e.g. 30 days from effective date of resignation"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Due Date (Days)
                </label>
                <input
                  type="number"
                  value={form.due_date_days}
                  onChange={e => setForm(f => ({ ...f, due_date_days: e.target.value }))}
                  placeholder="30"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Penalty Amount
                </label>
                <input
                  value={form.penalty_amount}
                  onChange={e => setForm(f => ({ ...f, penalty_amount: e.target.value }))}
                  placeholder="e.g. Min ₹50,000 / Max ₹5,00,000"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Penalty Section Reference
                </label>
                <input
                  value={form.penalty_section}
                  onChange={e => setForm(f => ({ ...f, penalty_section: e.target.value }))}
                  placeholder="e.g. Section 172"
                  className={ic}
                />
              </div>
              <div style={{ gridColumn: 'span 2' }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Penalty Provision (Description)
                </label>
                <input
                  value={form.penalty_provision}
                  onChange={e => setForm(f => ({ ...f, penalty_provision: e.target.value }))}
                  placeholder="Describe the penalty provision..."
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Related Sections (comma separated)
                </label>
                <input
                  value={form.related_sections}
                  onChange={e => setForm(f => ({ ...f, related_sections: e.target.value }))}
                  placeholder="167, 169, 172"
                  className={ic}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Keywords (comma separated)
                </label>
                <input
                  value={form.keywords}
                  onChange={e => setForm(f => ({ ...f, keywords: e.target.value }))}
                  placeholder="resignation, director, DIR-12"
                  className={ic}
                />
              </div>
            </div>
          </div>

          {/* ─ PRACTICAL NOTES ─ */}
          <div style={{ marginBottom: 28 }}>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 14 }}>
              CA Practical Notes & Tips
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Practical Notes
                </label>
                <textarea
                  rows={3}
                  value={form.practical_notes}
                  onChange={e => setForm(f => ({ ...f, practical_notes: e.target.value }))}
                  placeholder="Practical guidance for CA professionals..."
                  className={ta}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  CA Tips
                </label>
                <textarea
                  rows={3}
                  value={form.ca_tips}
                  onChange={e => setForm(f => ({ ...f, ca_tips: e.target.value }))}
                  placeholder="Important tips and best practices..."
                  className={ta}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                  Common Mistakes
                </label>
                <textarea
                  rows={3}
                  value={form.common_mistakes}
                  onChange={e => setForm(f => ({ ...f, common_mistakes: e.target.value }))}
                  placeholder="Common mistakes to avoid..."
                  className={ta}
                />
              </div>
            </div>
          </div>

          {/* ─ AMENDMENT ─ */}
          <div style={{ marginBottom: 28 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
              <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5 }}>
                Amendment Details
              </p>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#475569', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={form.is_amended}
                  onChange={e => setForm(f => ({ ...f, is_amended: e.target.checked }))}
                />
                This section has been amended
              </label>
            </div>
            {form.is_amended && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14 }}>
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                    Amended By
                  </label>
                  <input
                    value={form.amended_by}
                    onChange={e => setForm(f => ({ ...f, amended_by: e.target.value }))}
                    placeholder="Companies (Amendment) Act 2020"
                    className={ic}
                  />
                </div>
                <div>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                    Amendment Date
                  </label>
                  <input
                    type="date"
                    value={form.amendment_date}
                    onChange={e => setForm(f => ({ ...f, amendment_date: e.target.value }))}
                    className={ic}
                  />
                </div>
                <div style={{ gridColumn: 'span 3' }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                    Amendment Notes
                  </label>
                  <textarea
                    rows={2}
                    value={form.amendment_notes}
                    onChange={e => setForm(f => ({ ...f, amendment_notes: e.target.value }))}
                    placeholder="What changed and why..."
                    className={ta}
                  />
                </div>
                <div style={{ gridColumn: 'span 3' }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>
                    Original Text (Before Amendment)
                  </label>
                  <textarea
                    rows={3}
                    value={form.original_text}
                    onChange={e => setForm(f => ({ ...f, original_text: e.target.value }))}
                    placeholder="Paste original text before amendment..."
                    className={ta}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 24px', borderTop: '1px solid #e2e8f0',
          background: '#f8fafc', borderRadius: '0 0 20px 20px',
          display: 'flex', justifyContent: 'flex-end', gap: 12,
        }}>
          <button onClick={onClose} style={{
            padding: '10px 20px', borderRadius: 12,
            border: '1px solid #e2e8f0', background: 'white',
            color: '#64748b', fontSize: 13, fontWeight: 500, cursor: 'pointer',
          }}>
            Cancel
          </button>
          <button onClick={handleSave} disabled={saving} style={{
            padding: '10px 24px', borderRadius: 12,
            background: saving ? '#94a3b8' : C.navy,
            color: 'white', fontSize: 13, fontWeight: 600,
            border: 'none', cursor: saving ? 'not-allowed' : 'pointer',
            boxShadow: '0 4px 12px rgba(0,32,110,0.3)',
          }}>
            {saving ? 'Saving...' : isEdit ? 'Update Section' : 'Save Section'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── MAIN LAW MODULE ─────────────────────────────────────────────────────────
function LawModule() {
  const [view, setView] = useState('home');
  const [acts, setActs] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectedAct, setSelectedAct] = useState(null);
  const [selectedChapter, setSelectedChapter] = useState(null);
  const [chapters, setChapters] = useState([]);
  const [sections, setSections] = useState([]);
  const [rules, setRules] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [circulars, setCirculars] = useState([]);
  const [search, setSearch] = useState('');
  const [searchResults, setSearchResults] = useState(null);
  const [searching, setSearching] = useState(false);
  const [showSectionForm, setShowSectionForm] = useState(false);
  const [editingSection, setEditingSection] = useState(null);
  const [readingSection, setReadingSection] = useState(null);
  const [showActForm, setShowActForm] = useState(false);
  const [editingAct, setEditingAct] = useState(null);
  const [showChapterForm, setShowChapterForm] = useState(false);
  const [editingChapter, setEditingChapter] = useState(null);
  const [actTab, setActTab] = useState('sections');
  const [openMenuId, setOpenMenuId] = useState(null);
  const [savingAct, setSavingAct] = useState(false);
  const [savingChapter, setSavingChapter] = useState(false);

  const EMPTY_ACT = {
    act_name: '', act_short_title: '', act_year: '',
    act_number: '', ministry: 'Ministry of Corporate Affairs',
    description: '', enacted_date: '', effective_date: '',
    last_amended_date: '', last_amended_by: '', gazette_number: '',
    status: 'Active', display_order: '', is_published: false, notes: '',
  };

  const EMPTY_CHAPTER = {
    chapter_number: '', chapter_title: '', chapter_description: '',
    sections_from: '', sections_to: '', display_order: '', is_published: false, notes: '',
  };

  const [actForm, setActForm] = useState(EMPTY_ACT);
  const [chapterForm, setChapterForm] = useState(EMPTY_CHAPTER);

  // Global kebab close
  useEffect(() => {
    const h = e => { if (!e.target.closest('[data-kebab]')) setOpenMenuId(null); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  // Fetch acts + stats on mount
  const fetchActs = useCallback(async () => {
    setLoading(true);
    try {
      const [actsRes, statsRes] = await Promise.all([
        fetch(`${API}/acts`, { headers: getHeaders() }),
        fetch(`${API}/stats`, { headers: getHeaders() }),
      ]);
      const actsData = await actsRes.json();
      const statsData = await statsRes.json();
      setActs(Array.isArray(actsData) ? actsData : []);
      setStats(statsData || {});
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchActs(); }, [fetchActs]);

  // Fetch chapters + sections when act selected
  const fetchActContent = useCallback(async (actId, tab = 'sections') => {
    try {
      const urls = {
        sections: `${API}/acts/${actId}/sections`,
        chapters: `${API}/acts/${actId}/chapters`,
        rules: `${API}/acts/${actId}/rules`,
        schedules: `${API}/acts/${actId}/schedules`,
      };

      const [chapRes, contentRes] = await Promise.all([
        fetch(`${API}/acts/${actId}/chapters`, { headers: getHeaders() }),
        fetch(urls[tab] || urls.sections, { headers: getHeaders() }),
      ]);

      const chapData = await chapRes.json();
      const contentData = await contentRes.json();

      setChapters(Array.isArray(chapData) ? chapData : []);

      if (tab === 'sections') setSections(Array.isArray(contentData) ? contentData : []);
      else if (tab === 'rules') setRules(Array.isArray(contentData) ? contentData : []);
      else if (tab === 'schedules') setSchedules(Array.isArray(contentData) ? contentData : []);
    } catch (e) { console.error(e); }
  }, []);

  const handleSelectAct = async (act) => {
    setSelectedAct(act);
    setSelectedChapter(null);
    setActTab('sections');
    setView('act');
    await fetchActContent(act.id, 'sections');
  };

  const handleTabChange = async (tab) => {
    setActTab(tab);
    if (selectedAct) await fetchActContent(selectedAct.id, tab);
  };

  // Search
  const handleSearch = useCallback(async (q) => {
    if (!q || q.trim().length < 2) { setSearchResults(null); return; }
    setSearching(true);
    try {
      const params = new URLSearchParams({ q });
      if (selectedAct) params.append('act_id', selectedAct.id);
      const res = await fetch(`${API}/search?${params}`, { headers: getHeaders() });
      const data = await res.json();
      setSearchResults(data);
    } catch (e) { setSearchResults(null); }
    finally { setSearching(false); }
  }, [selectedAct]);

  useEffect(() => {
    const timer = setTimeout(() => { if (search) handleSearch(search); else setSearchResults(null); }, 400);
    return () => clearTimeout(timer);
  }, [search, handleSearch]);

  // Act CRUD
  const handleSaveAct = async () => {
    if (!actForm.act_name) { alert('Act name required'); return; }
    setSavingAct(true);
    try {
      const url = editingAct ? `${API}/acts/${editingAct.id}` : `${API}/acts`;
      const res = await fetch(url, {
        method: editingAct ? 'PUT' : 'POST',
        headers: getHeaders(),
        body: JSON.stringify(actForm),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      await fetchActs();
      setShowActForm(false);
      setEditingAct(null);
      setActForm(EMPTY_ACT);
    } catch (e) { alert('Server error'); }
    finally { setSavingAct(false); }
  };

  const handleDeleteAct = async (act) => {
    if (!window.confirm(`Delete "${act.act_name}"? All chapters, sections and rules will be deleted.`)) return;
    await fetch(`${API}/acts/${act.id}`, { method: 'DELETE', headers: getHeaders() });
    await fetchActs();
    if (selectedAct?.id === act.id) { setSelectedAct(null); setView('home'); }
  };

  // Chapter CRUD
  const handleSaveChapter = async () => {
    if (!chapterForm.chapter_number || !chapterForm.chapter_title) {
      alert('Chapter number and title required'); return;
    }
    setSavingChapter(true);
    try {
      const url = editingChapter
        ? `${API}/acts/${selectedAct.id}/chapters/${editingChapter.id}`
        : `${API}/acts/${selectedAct.id}/chapters`;
      const res = await fetch(url, {
        method: editingChapter ? 'PUT' : 'POST',
        headers: getHeaders(),
        body: JSON.stringify(chapterForm),
      });
      const data = await res.json();
      if (!res.ok) { alert(data.message); return; }
      await fetchActContent(selectedAct.id, actTab);
      setShowChapterForm(false);
      setEditingChapter(null);
      setChapterForm(EMPTY_CHAPTER);
    } catch (e) { alert('Server error'); }
    finally { setSavingChapter(false); }
  };

  const handleDeleteChapter = async (chapter) => {
    if (!window.confirm(`Delete Chapter ${chapter.chapter_number}?`)) return;
    await fetch(`${API}/acts/${selectedAct.id}/chapters/${chapter.id}`, { method: 'DELETE', headers: getHeaders() });
    await fetchActContent(selectedAct.id, actTab);
  };

  // Section CRUD
  const handleSectionSaved = async (data) => {
    setShowSectionForm(false);
    setEditingSection(null);
    await fetchActContent(selectedAct.id, 'sections');
    // Refresh act to update section count
    const res = await fetch(`${API}/acts/${selectedAct.id}`, { headers: getHeaders() });
    const updated = await res.json();
    if (res.ok) {
      setSelectedAct(updated);
      setActs(prev => prev.map(a => a.id === updated.id ? { ...a, section_count: updated.section_count } : a));
    }
  };

  const handleDeleteSection = async (section) => {
    if (!window.confirm(`Delete Section ${section.section_number}?`)) return;
    await fetch(`${API}/acts/${selectedAct.id}/sections/${section.id}`, { method: 'DELETE', headers: getHeaders() });
    await fetchActContent(selectedAct.id, 'sections');
  };

  const filteredSections = sections.filter(s => {
    if (selectedChapter) return s.chapter_id === selectedChapter.id;
    return true;
  });

  // ── HOME VIEW ────────────────────────────────────────────────────────────
  if (view === 'home' || view === 'search') {
    return (
      <div style={{ padding: 24, background: '#f8fafc', minHeight: '100vh' }}>

        {/* Header Banner */}
        <div style={{
          borderRadius: 20, overflow: 'hidden', position: 'relative', marginBottom: 24,
          background: `linear-gradient(135deg, ${C.navy} 0%, #001A5C 100%)`,
        }}>
          <div style={{
            position: 'absolute', top: 0, right: 0, width: 200, height: 200,
            borderRadius: '50%', background: C.orange, opacity: 0.1,
            transform: 'translate(30%, -30%)',
          }} />
          <div style={{ position: 'relative', padding: '28px 32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <div style={{ width: 6, height: 6, borderRadius: '50%', background: C.orange }} />
                <p style={{ fontSize: 10, fontWeight: 700, color: C.orange, letterSpacing: 3, textTransform: 'uppercase' }}>
                  ChanakyaX Law Module
                </p>
              </div>
              <h1 style={{ fontSize: 24, fontWeight: 800, color: 'white', marginBottom: 6 }}>
                Companies Act Library
              </h1>
              <p style={{ fontSize: 13, color: '#93c5fd' }}>
                Complete reference database · Acts · Rules · Schedules · Circulars
              </p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              {[
                { label: 'Acts', value: stats.total_acts || 0 },
                { label: 'Sections', value: stats.total_sections || 0 },
                { label: 'Published', value: stats.published_sections || 0 },
              ].map(s => (
                <div key={s.label} style={{ textAlign: 'center' }}>
                  <p style={{ fontSize: 22, fontWeight: 800, color: 'white' }}>{s.value}</p>
                  <p style={{ fontSize: 11, color: '#93c5fd' }}>{s.label}</p>
                </div>
              ))}
              <button
                onClick={() => { setEditingAct(null); setActForm(EMPTY_ACT); setShowActForm(true); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  padding: '10px 20px', borderRadius: 12,
                  background: C.orange, color: 'white',
                  border: 'none', fontSize: 13, fontWeight: 700,
                  cursor: 'pointer', boxShadow: '0 4px 15px rgba(255,132,0,0.4)',
                }}
              >
                {Icons.add} Add Act
              </button>
            </div>
          </div>
        </div>

        {/* Search Bar */}
        <div style={{
          background: 'white', borderRadius: 16, padding: '16px 20px',
          border: '1px solid #e2e8f0', marginBottom: 24,
          display: 'flex', alignItems: 'center', gap: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}>
          <span style={{ color: '#94a3b8' }}>{Icons.search}</span>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search sections, keywords, form numbers... (e.g. DIR-12, resignation, Section 168)"
            style={{
              flex: 1, border: 'none', outline: 'none',
              fontSize: 14, color: '#1e293b', background: 'transparent',
            }}
          />
          {searching && <span style={{ fontSize: 12, color: '#94a3b8' }}>Searching...</span>}
          {search && (
            <button onClick={() => { setSearch(''); setSearchResults(null); }}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8' }}>
              {Icons.close}
            </button>
          )}
        </div>

        {/* Search Results */}
        {searchResults && (
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
              <p style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>
                Search Results
              </p>
              <span style={{
                padding: '2px 10px', borderRadius: 20, fontSize: 11,
                background: C.navyLight, color: C.navy, fontWeight: 600,
              }}>
                {searchResults.total} found
              </span>
            </div>

            {/* Section Results */}
            {searchResults.sections?.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
                  Sections ({searchResults.sections.length})
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {searchResults.sections.map(s => (
                    <button
                      key={s.id}
                      onClick={() => setReadingSection(s)}
                      style={{
                        background: 'white', borderRadius: 14, padding: '14px 18px',
                        border: '1px solid #e2e8f0', textAlign: 'left', cursor: 'pointer',
                        transition: 'all 0.15s',
                      }}
                      onMouseEnter={e => { e.currentTarget.style.borderColor = C.navy; e.currentTarget.style.boxShadow = '0 2px 12px rgba(0,32,110,0.1)'; }}
                      onMouseLeave={e => { e.currentTarget.style.borderColor = '#e2e8f0'; e.currentTarget.style.boxShadow = 'none'; }}
                    >
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                        <span style={{
                          padding: '3px 10px', borderRadius: 8, fontSize: 11, fontWeight: 700,
                          background: C.navyLight, color: C.navy,
                          border: `1px solid ${C.navy}20`, flexShrink: 0,
                        }}>
                          § {s.section_number}
                        </span>
                        <div>
                          <p style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>{s.section_title}</p>
                          {s.section_text_preview && (
                            <p style={{ fontSize: 12, color: '#64748b', marginTop: 4, lineHeight: 1.6 }}>
                              {s.section_text_preview}...
                            </p>
                          )}
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Rules Results */}
            {searchResults.rules?.length > 0 && (
              <div style={{ marginBottom: 20 }}>
                <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>
                  Rules ({searchResults.rules.length})
                </p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {searchResults.rules.map(r => (
                    <div key={r.id} style={{
                      background: 'white', borderRadius: 14, padding: '14px 18px',
                      border: '1px solid #e2e8f0',
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{
                          padding: '3px 10px', borderRadius: 8, fontSize: 11, fontWeight: 700,
                          background: C.orangeLight, color: C.orange, flexShrink: 0,
                        }}>
                          Rule {r.rule_number}
                        </span>
                        <div>
                          <p style={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>{r.rule_title}</p>
                          <p style={{ fontSize: 11, color: '#94a3b8' }}>{r.rule_set_name}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {searchResults.total === 0 && (
              <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>
                <p style={{ fontSize: 14, fontWeight: 600 }}>No results found for "{search}"</p>
                <p style={{ fontSize: 12, marginTop: 6 }}>Try different keywords or section numbers</p>
              </div>
            )}
          </div>
        )}

        {/* Acts Grid */}
        {!searchResults && (
          <>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 14 }}>
              Available Acts
            </p>

            {loading ? (
              <div style={{ textAlign: 'center', padding: 60, color: '#94a3b8' }}>Loading library...</div>
            ) : acts.length === 0 ? (
              <div style={{
                background: 'white', borderRadius: 20, padding: 60,
                textAlign: 'center', border: '1px solid #e2e8f0',
              }}>
                <div style={{
                  width: 64, height: 64, borderRadius: 20, margin: '0 auto 16px',
                  background: C.navyLight, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', color: C.navy,
                }}>
                  {Icons.act}
                </div>
                <p style={{ fontSize: 15, fontWeight: 700, color: C.navy }}>No Acts Added Yet</p>
                <p style={{ fontSize: 13, color: '#94a3b8', marginTop: 6 }}>
                  Click "Add Act" to start building the law library
                </p>
                <button
                  onClick={() => { setEditingAct(null); setActForm(EMPTY_ACT); setShowActForm(true); }}
                  style={{
                    marginTop: 20, display: 'inline-flex', alignItems: 'center', gap: 8,
                    padding: '10px 24px', borderRadius: 12,
                    background: C.navy, color: 'white',
                    border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  {Icons.add} Add First Act
                </button>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
                {acts.map(act => (
                  <div
                    key={act.id}
                    style={{
                      background: 'white', borderRadius: 20, overflow: 'hidden',
                      border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                      transition: 'all 0.2s',
                    }}
                    onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,32,110,0.12)'; e.currentTarget.style.borderColor = C.navy + '40'; }}
                    onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                  >
                    {/* Card Header */}
                    <div style={{
                      padding: '18px 20px', background: `linear-gradient(135deg, ${C.navyLight}, #f0f9ff)`,
                      borderBottom: '1px solid #e2e8f0',
                    }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                          <div style={{
                            width: 44, height: 44, borderRadius: 14, background: C.navy,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: 'white', flexShrink: 0,
                          }}>
                            {Icons.act}
                          </div>
                          <div>
                            <p style={{ fontSize: 13, fontWeight: 800, color: C.navy, lineHeight: 1.3 }}>
                              {act.act_name}
                            </p>
                            {act.act_year && (
                              <p style={{ fontSize: 11, color: '#64748b', marginTop: 3 }}>
                                Act No. {act.act_number || '—'} of {act.act_year}
                              </p>
                            )}
                          </div>
                        </div>
                        <div style={{ position: 'relative' }} data-kebab>
                          <button
                            onClick={e => { e.stopPropagation(); setOpenMenuId(openMenuId === act.id ? null : act.id); }}
                            style={{
                              width: 30, height: 30, borderRadius: 8,
                              border: '1px solid #e2e8f0', background: 'white',
                              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
                              color: '#64748b',
                            }}
                            data-kebab
                          >
                            {Icons.kebab}
                          </button>
                          {openMenuId === act.id && (
                            <div style={{
                              position: 'absolute', right: 0, top: 36, zIndex: 50,
                              background: 'white', borderRadius: 14, border: '1px solid #e2e8f0',
                              boxShadow: '0 8px 24px rgba(0,0,0,0.12)', padding: 6, width: 160,
                            }} data-kebab>
                              <button
                                onClick={() => { handleSelectAct(act); setOpenMenuId(null); }}
                                style={{
                                  width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                                  padding: '8px 12px', borderRadius: 10, border: 'none',
                                  background: 'none', fontSize: 13, color: C.navy,
                                  fontWeight: 600, cursor: 'pointer', textAlign: 'left',
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = C.navyLight}
                                onMouseLeave={e => e.currentTarget.style.background = 'none'}
                              >
                                {Icons.eye} Open Act
                              </button>
                              <button
                                onClick={() => { setEditingAct(act); setActForm({ ...act, enacted_date: act.enacted_date ? String(act.enacted_date).slice(0,10) : '', effective_date: act.effective_date ? String(act.effective_date).slice(0,10) : '', last_amended_date: act.last_amended_date ? String(act.last_amended_date).slice(0,10) : '' }); setShowActForm(true); setOpenMenuId(null); }}
                                style={{
                                  width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                                  padding: '8px 12px', borderRadius: 10, border: 'none',
                                  background: 'none', fontSize: 13, color: '#475569',
                                  cursor: 'pointer', textAlign: 'left',
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                onMouseLeave={e => e.currentTarget.style.background = 'none'}
                              >
                                {Icons.edit} Edit Act
                              </button>
                              <div style={{ borderTop: '1px solid #e2e8f0', margin: '4px 0' }} />
                              <button
                                onClick={() => { handleDeleteAct(act); setOpenMenuId(null); }}
                                style={{
                                  width: '100%', display: 'flex', alignItems: 'center', gap: 8,
                                  padding: '8px 12px', borderRadius: 10, border: 'none',
                                  background: 'none', fontSize: 13, color: '#dc2626',
                                  cursor: 'pointer', textAlign: 'left',
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = '#fef2f2'}
                                onMouseLeave={e => e.currentTarget.style.background = 'none'}
                              >
                                {Icons.delete} Delete
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Card Body */}
                    <div style={{ padding: '14px 20px' }}>
                      {act.description && (
                        <p style={{ fontSize: 12, color: '#64748b', lineHeight: 1.6, marginBottom: 14 }}>
                          {act.description.slice(0, 100)}{act.description.length > 100 ? '...' : ''}
                        </p>
                      )}
                      <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ fontSize: 18, fontWeight: 800, color: C.navy }}>{act.chapter_count || 0}</p>
                          <p style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600 }}>Chapters</p>
                        </div>
                        <div style={{ width: 1, background: '#e2e8f0' }} />
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ fontSize: 18, fontWeight: 800, color: C.navy }}>{act.section_count || 0}</p>
                          <p style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600 }}>Sections</p>
                        </div>
                        <div style={{ width: 1, background: '#e2e8f0' }} />
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ fontSize: 18, fontWeight: 800, color: act.status === 'Active' ? '#059669' : '#dc2626' }}>
                            {act.status}
                          </p>
                          <p style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600 }}>Status</p>
                        </div>
                      </div>
                      <button
                        onClick={() => handleSelectAct(act)}
                        style={{
                          width: '100%', padding: '10px', borderRadius: 12,
                          background: C.navy, color: 'white',
                          border: 'none', fontSize: 13, fontWeight: 600,
                          cursor: 'pointer', display: 'flex', alignItems: 'center',
                          justifyContent: 'center', gap: 8,
                          boxShadow: '0 4px 12px rgba(0,32,110,0.2)',
                        }}
                      >
                        {Icons.eye} Open Act
                      </button>
                    </div>

                    {/* Bottom Accent */}
                    <div style={{ height: 4, background: `linear-gradient(90deg, ${C.navy}, ${C.orange})` }} />
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {/* Act Form Modal */}
        {showActForm && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}>
            <div style={{
              background: 'white', borderRadius: 20, width: '100%', maxWidth: 680,
              maxHeight: '90vh', overflowY: 'auto',
              boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
            }}>
              <div style={{
                padding: '20px 24px', borderBottom: '1px solid #e2e8f0',
                background: `linear-gradient(135deg, ${C.navyLight}, ${C.orangeLight})`,
                borderRadius: '20px 20px 0 0',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 38, height: 38, borderRadius: 12, background: C.navy, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                    {Icons.act}
                  </div>
                  <div>
                    <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>
                      {editingAct ? 'Edit Act' : 'Add New Act'}
                    </p>
                    <p style={{ fontSize: 12, color: '#64748b' }}>Enter act details</p>
                  </div>
                </div>
                <button onClick={() => { setShowActForm(false); setEditingAct(null); setActForm(EMPTY_ACT); }}
                  style={{ width: 32, height: 32, borderRadius: 10, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>
                  {Icons.close}
                </button>
              </div>
              <div style={{ padding: 24 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16 }}>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Act Name *</label>
                    <input value={actForm.act_name} onChange={e => setActForm(f => ({ ...f, act_name: e.target.value }))} placeholder="e.g. Companies Act, 2013" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Short Title</label>
                    <input value={actForm.act_short_title} onChange={e => setActForm(f => ({ ...f, act_short_title: e.target.value }))} placeholder="e.g. CA 2013" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Year</label>
                    <input type="number" value={actForm.act_year} onChange={e => setActForm(f => ({ ...f, act_year: e.target.value }))} placeholder="2013" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Act Number</label>
                    <input value={actForm.act_number} onChange={e => setActForm(f => ({ ...f, act_number: e.target.value }))} placeholder="18" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Ministry</label>
                    <input value={actForm.ministry} onChange={e => setActForm(f => ({ ...f, ministry: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Enacted Date</label>
                    <input type="date" value={actForm.enacted_date} onChange={e => setActForm(f => ({ ...f, enacted_date: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Effective Date</label>
                    <input type="date" value={actForm.effective_date} onChange={e => setActForm(f => ({ ...f, effective_date: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Last Amended By</label>
                    <input value={actForm.last_amended_by} onChange={e => setActForm(f => ({ ...f, last_amended_by: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Last Amended Date</label>
                    <input type="date" value={actForm.last_amended_date} onChange={e => setActForm(f => ({ ...f, last_amended_date: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Gazette Number</label>
                    <input value={actForm.gazette_number} onChange={e => setActForm(f => ({ ...f, gazette_number: e.target.value }))} className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Status</label>
                    <select value={actForm.status} onChange={e => setActForm(f => ({ ...f, status: e.target.value }))} className={ic}>
                      <option>Active</option><option>Repealed</option><option>Amended</option>
                    </select>
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Description</label>
                    <textarea rows={3} value={actForm.description} onChange={e => setActForm(f => ({ ...f, description: e.target.value }))} className={ta} placeholder="Brief description of the act..." />
                  </div>
                  <div style={{ gridColumn: 'span 2', display: 'flex', gap: 16 }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#475569', cursor: 'pointer' }}>
                      <input type="checkbox" checked={actForm.is_published} onChange={e => setActForm(f => ({ ...f, is_published: e.target.checked }))} />
                      Published (visible to users)
                    </label>
                  </div>
                </div>
              </div>
              <div style={{
                padding: '16px 24px', borderTop: '1px solid #e2e8f0', background: '#f8fafc',
                borderRadius: '0 0 20px 20px', display: 'flex', justifyContent: 'flex-end', gap: 12,
              }}>
                <button onClick={() => { setShowActForm(false); setEditingAct(null); setActForm(EMPTY_ACT); }}
                  style={{ padding: '10px 20px', borderRadius: 12, border: '1px solid #e2e8f0', background: 'white', color: '#64748b', fontSize: 13, cursor: 'pointer' }}>
                  Cancel
                </button>
                <button onClick={handleSaveAct} disabled={savingAct}
                  style={{ padding: '10px 24px', borderRadius: 12, background: savingAct ? '#94a3b8' : C.navy, color: 'white', fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
                  {savingAct ? 'Saving...' : editingAct ? 'Update Act' : 'Save Act'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Section Reader Modal */}
        {readingSection && (
          <SectionReader
            section={readingSection}
            onClose={() => setReadingSection(null)}
          />
        )}
      </div>
    );
  }

  // ── ACT VIEW ─────────────────────────────────────────────────────────────
  if (view === 'act' && selectedAct) {
    const ACT_TABS = [
      { key: 'sections', label: 'Sections', icon: Icons.section, count: selectedAct.section_count || sections.length },
      { key: 'chapters', label: 'Chapters', icon: Icons.chapter, count: selectedAct.chapter_count || chapters.length },
      { key: 'rules', label: 'Rules', icon: Icons.rule, count: rules.length },
      { key: 'schedules', label: 'Schedules', icon: Icons.schedule, count: schedules.length },
    ];

    return (
      <div style={{ padding: 24, background: '#f8fafc', minHeight: '100vh' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <button
              onClick={() => { setView('home'); setSelectedAct(null); setSelectedChapter(null); }}
              style={{
                width: 36, height: 36, borderRadius: 10, border: '1px solid #e2e8f0',
                background: 'white', cursor: 'pointer', display: 'flex',
                alignItems: 'center', justifyContent: 'center', color: '#64748b',
              }}
            >
              {Icons.back}
            </button>
            <div>
              <p style={{ fontSize: 16, fontWeight: 800, color: C.navy }}>{selectedAct.act_name}</p>
              <p style={{ fontSize: 12, color: '#64748b' }}>
                Act {selectedAct.act_number && `No. ${selectedAct.act_number}`} of {selectedAct.act_year}
                {selectedAct.ministry && ` · ${selectedAct.ministry}`}
              </p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            {actTab === 'sections' && (
              <button
                onClick={() => { setEditingSection(null); setShowSectionForm(true); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  padding: '9px 18px', borderRadius: 12,
                  background: C.navy, color: 'white',
                  border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  boxShadow: '0 4px 12px rgba(0,32,110,0.25)',
                }}
              >
                {Icons.add} Add Section
              </button>
            )}
            {actTab === 'chapters' && (
              <button
                onClick={() => { setEditingChapter(null); setChapterForm(EMPTY_CHAPTER); setShowChapterForm(true); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  padding: '9px 18px', borderRadius: 12,
                  background: C.orange, color: 'white',
                  border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                }}
              >
                {Icons.add} Add Chapter
              </button>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div style={{
          background: 'white', borderRadius: 20, border: '1px solid #e2e8f0',
          overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        }}>
          {/* Tab Bar */}
          <div style={{ borderBottom: '1px solid #e2e8f0', display: 'flex', padding: '0 20px' }}>
            {ACT_TABS.map(tab => (
              <button
                key={tab.key}
                onClick={() => handleTabChange(tab.key)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 8,
                  padding: '14px 16px', border: 'none', background: 'none',
                  fontSize: 13, fontWeight: actTab === tab.key ? 700 : 500,
                  color: actTab === tab.key ? C.navy : '#94a3b8',
                  borderBottom: `2px solid ${actTab === tab.key ? C.navy : 'transparent'}`,
                  cursor: 'pointer', transition: 'all 0.15s',
                }}
              >
                <span style={{ color: actTab === tab.key ? C.navy : '#94a3b8' }}>{tab.icon}</span>
                {tab.label}
                <span style={{
                  padding: '1px 7px', borderRadius: 20, fontSize: 10, fontWeight: 700,
                  background: actTab === tab.key ? C.navyLight : '#f1f5f9',
                  color: actTab === tab.key ? C.navy : '#94a3b8',
                }}>
                  {tab.count}
                </span>
              </button>
            ))}
          </div>

          {/* SECTIONS TAB */}
          {actTab === 'sections' && (
            <div>
              {/* Chapter Filter Indicator */}
              {selectedChapter && (
                <div style={{
                  padding: '10px 24px',
                  borderBottom: '1px solid #e2e8f0',
                  display: 'flex', alignItems: 'center', gap: 10,
                  background: C.navyLight,
                }}>
                  <span style={{ fontSize: 12, color: C.navy, fontWeight: 600 }}>
                    Filtered by: Chapter {selectedChapter.chapter_number} — {selectedChapter.chapter_title}
                  </span>
                  <button
                    onClick={() => setSelectedChapter(null)}
                    style={{
                      display: 'flex', alignItems: 'center', gap: 4,
                      padding: '3px 10px', borderRadius: 8,
                      background: 'white', color: '#64748b',
                      border: '1px solid #e2e8f0',
                      fontSize: 11, fontWeight: 600, cursor: 'pointer',
                    }}
                  >
                    {Icons.close} Clear Filter
                  </button>
                </div>
              )}
              {filteredSections.length === 0 ? (
                <div style={{ padding: 60, textAlign: 'center' }}>
                  <div style={{
                    width: 56, height: 56, borderRadius: 18, margin: '0 auto 16px',
                    background: C.navyLight, display: 'flex', alignItems: 'center',
                    justifyContent: 'center', color: C.navy,
                  }}>
                    {Icons.section}
                  </div>
                  <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>No sections added yet</p>
                  <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 6 }}>
                    Click "Add Section" to start adding sections
                  </p>
                </div>
              ) : (
                <div>
                  {filteredSections.map((s, idx) => (
                    <div
                      key={s.id}
                      style={{
                        borderBottom: idx < filteredSections.length - 1 ? '1px solid #f1f5f9' : 'none',
                        padding: '16px 24px',
                        transition: 'background 0.15s',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16 }}>
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14, flex: 1, minWidth: 0 }}>
                          {/* Section Number Badge */}
<div style={{
                            flexShrink: 0,
                            padding: '4px 10px',
                            borderRadius: 8,
                            background: '#f1f5f9',
                            border: '1px solid #e2e8f0',
                            fontSize: 12,
                            fontWeight: 700,
                            color: '#475569',
                            letterSpacing: 0.3,
                            whiteSpace: 'nowrap',
                            alignSelf: 'flex-start',
                            marginTop: 2,
                          }}>
                            {s.section_number}
                          </div>

                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                              <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>
                                {s.section_title}
                              </p>
                              {!s.is_published && (
                                <span style={{
                                  padding: '1px 8px', borderRadius: 20, fontSize: 10, fontWeight: 700,
                                  background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
                                }}>
                                  Draft
                                </span>
                              )}
                              {s.is_amended && (
                                <span style={{
                                  padding: '1px 8px', borderRadius: 20, fontSize: 10, fontWeight: 700,
                                  background: C.orangeLight, color: C.orange, border: `1px solid ${C.orange}30`,
                                }}>
                                  Amended
                                </span>
                              )}
                              {s.chapter_title && (
                                <span style={{
                                  padding: '1px 8px', borderRadius: 20, fontSize: 10, fontWeight: 600,
                                  background: '#f1f5f9', color: '#64748b',
                                }}>
                                  Ch. {s.chapter_number}
                                </span>
                              )}
                            </div>

                            {s.section_text && (
                              <p style={{ fontSize: 12, color: '#64748b', lineHeight: 1.6 }}>
                                {s.section_text.slice(0, 180)}{s.section_text.length > 180 ? '...' : ''}
                              </p>
                            )}

                            {/* Tags Row */}
                            <div style={{ display: 'flex', gap: 8, marginTop: 8, flexWrap: 'wrap' }}>
                              {Array.isArray(s.related_forms) && s.related_forms.map((f, i) => (
                                <span key={i} style={{
                                  padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600,
                                  background: C.navyLight, color: C.navy,
                                }}>
                                  {f}
                                </span>
                              ))}
                              {s.due_date_logic && (
                                <span style={{
                                  padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600,
                                  background: '#ecfdf5', color: '#059669',
                                }}>
                                  ⏰ {s.due_date_days ? `${s.due_date_days} days` : 'Due date set'}
                                </span>
                              )}
                              {s.penalty_amount && (
                                <span style={{
                                  padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600,
                                  background: '#fef2f2', color: '#dc2626',
                                }}>
                                  ⚠️ Penalty
                                </span>
                              )}
                              {s.practical_notes && (
                                <span style={{
                                  padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600,
                                  background: '#f0f9ff', color: '#0369a1',
                                }}>
                                  💡 CA Notes
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Actions */}
                        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                          <button
                            onClick={() => setReadingSection(s)}
                            style={{
                              width: 32, height: 32, borderRadius: 9,
                              border: `1px solid ${C.navy}30`, background: C.navyLight,
                              color: C.navy, cursor: 'pointer',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}
                            title="Read Section"
                          >
                            {Icons.eye}
                          </button>
                          <button
                            onClick={() => { setEditingSection(s); setShowSectionForm(true); }}
                            style={{
                              width: 32, height: 32, borderRadius: 9,
                              border: '1px solid #e2e8f0', background: 'white',
                              color: '#64748b', cursor: 'pointer',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}
                            title="Edit Section"
                          >
                            {Icons.edit}
                          </button>
                          <button
                            onClick={() => handleDeleteSection(s)}
                            style={{
                              width: 32, height: 32, borderRadius: 9,
                              border: '1px solid #fecaca', background: '#fef2f2',
                              color: '#dc2626', cursor: 'pointer',
                              display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}
                            title="Delete Section"
                          >
                            {Icons.delete}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* CHAPTERS TAB */}
          {actTab === 'chapters' && (
            <div>
              {chapters.length === 0 ? (
                <div style={{ padding: 60, textAlign: 'center' }}>
                  <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>No chapters added</p>
                  <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 6 }}>Add chapters to organize sections</p>
                </div>
              ) : (
                <div>
                  {chapters.map((ch, idx) => (
                    <div
                      key={ch.id}
                      style={{
                        borderBottom: idx < chapters.length - 1 ? '1px solid #f1f5f9' : 'none',
                        padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        transition: 'background 0.15s',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#fafafa'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                          width: 44, height: 44, borderRadius: 14, background: C.orangeLight,
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: C.orange, fontSize: 12, fontWeight: 800,
                        }}>
                          {ch.chapter_number}
                        </div>
                        <div>
                          <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>{ch.chapter_title}</p>
                          <p style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>
                            {ch.chapter_description && ch.chapter_description.slice(0, 80)}
                            {ch.sections_from && ` · Sections ${ch.sections_from}${ch.sections_to ? `–${ch.sections_to}` : ''}`}
                          </p>
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <button
                          onClick={() => {
                            setSelectedChapter(ch);
                            setActTab('sections');
                            fetchActContent(selectedAct.id, 'sections');
                          }}
                          style={{
                            display: 'flex', alignItems: 'center', gap: 6,
                            padding: '5px 12px', borderRadius: 8,
                            background: C.navyLight, color: C.navy,
                            border: `1px solid ${C.navy}20`,
                            fontSize: 12, fontWeight: 600, cursor: 'pointer',
                          }}
                        >
                          {Icons.eye}
                          <span>{ch.section_count || 0} Sections</span>
                        </button>
                        <button
                          onClick={() => { setEditingChapter(ch); setChapterForm({ ...ch }); setShowChapterForm(true); }}
                          style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', color: '#64748b', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          {Icons.edit}
                        </button>
                        <button
                          onClick={() => handleDeleteChapter(ch)}
                          style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #fecaca', background: '#fef2f2', color: '#dc2626', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                        >
                          {Icons.delete}
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* RULES TAB */}
          {actTab === 'rules' && (
            <div>
              <div style={{ padding: '14px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  onClick={() => alert('Rule form coming in next patch!')}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '8px 16px', borderRadius: 10,
                    background: C.orange, color: 'white',
                    border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  {Icons.add} Add Rule
                </button>
              </div>
              {rules.length === 0 ? (
                <div style={{ padding: 60, textAlign: 'center', color: '#94a3b8' }}>
                  <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>No rules added</p>
                  <p style={{ fontSize: 12, marginTop: 6 }}>Add rules linked to this act</p>
                </div>
              ) : (
                <div>
                  {rules.map((r, idx) => (
                    <div key={r.id} style={{
                      borderBottom: '1px solid #f1f5f9', padding: '14px 24px',
                      display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 14,
                    }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                        <span style={{
                          padding: '3px 10px', borderRadius: 8, fontSize: 11, fontWeight: 700,
                          background: C.orangeLight, color: C.orange, flexShrink: 0,
                        }}>
                          Rule {r.rule_number}
                        </span>
                        <div>
                          <p style={{ fontSize: 13, fontWeight: 700, color: '#1e293b' }}>{r.rule_title}</p>
                          <p style={{ fontSize: 11, color: '#94a3b8' }}>{r.rule_set_name}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* SCHEDULES TAB */}
          {actTab === 'schedules' && (
            <div>
              <div style={{ padding: '14px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end' }}>
                <button
                  onClick={() => alert('Schedule form coming in next patch!')}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '8px 16px', borderRadius: 10,
                    background: C.navy, color: 'white',
                    border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                  }}
                >
                  {Icons.add} Add Schedule
                </button>
              </div>
              {schedules.length === 0 ? (
                <div style={{ padding: 60, textAlign: 'center', color: '#94a3b8' }}>
                  <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>No schedules added</p>
                </div>
              ) : (
                <div>
                  {schedules.map(s => (
                    <div key={s.id} style={{ borderBottom: '1px solid #f1f5f9', padding: '14px 24px' }}>
                      <p style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Schedule {s.schedule_number} — {s.schedule_title}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Section Form Modal */}
        {showSectionForm && (
          <SectionForm
            actId={selectedAct.id}
            chapters={chapters}
            section={editingSection}
            onSave={handleSectionSaved}
            onClose={() => { setShowSectionForm(false); setEditingSection(null); }}
          />
        )}

        {/* Section Reader */}
        {readingSection && (
          <SectionReader
            section={readingSection}
            onClose={() => setReadingSection(null)}
            onEdit={() => { setEditingSection(readingSection); setReadingSection(null); setShowSectionForm(true); }}
          />
        )}

        {/* Chapter Form Modal */}
        {showChapterForm && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}>
            <div style={{
              background: 'white', borderRadius: 20, width: '100%', maxWidth: 560,
              boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
            }}>
              <div style={{
                padding: '18px 24px', borderBottom: '1px solid #e2e8f0',
                background: `linear-gradient(135deg, ${C.orangeLight}, #fffbeb)`,
                borderRadius: '20px 20px 0 0',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 36, height: 36, borderRadius: 10, background: C.orange, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white' }}>
                    {Icons.chapter}
                  </div>
                  <p style={{ fontSize: 14, fontWeight: 700, color: C.navy }}>
                    {editingChapter ? 'Edit Chapter' : 'Add Chapter'}
                  </p>
                </div>
                <button onClick={() => { setShowChapterForm(false); setEditingChapter(null); setChapterForm(EMPTY_CHAPTER); }}
                  style={{ width: 30, height: 30, borderRadius: 9, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>
                  {Icons.close}
                </button>
              </div>
              <div style={{ padding: 24 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Chapter Number *</label>
                    <input value={chapterForm.chapter_number} onChange={e => setChapterForm(f => ({ ...f, chapter_number: e.target.value }))} placeholder="XI" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Display Order</label>
                    <input type="number" value={chapterForm.display_order} onChange={e => setChapterForm(f => ({ ...f, display_order: e.target.value }))} className={ic} />
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Chapter Title *</label>
                    <input value={chapterForm.chapter_title} onChange={e => setChapterForm(f => ({ ...f, chapter_title: e.target.value }))} placeholder="Appointment and Qualifications of Directors" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Sections From</label>
                    <input value={chapterForm.sections_from} onChange={e => setChapterForm(f => ({ ...f, sections_from: e.target.value }))} placeholder="149" className={ic} />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Sections To</label>
                    <input value={chapterForm.sections_to} onChange={e => setChapterForm(f => ({ ...f, sections_to: e.target.value }))} placeholder="172" className={ic} />
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ display: 'block', fontSize: 12, fontWeight: 500, color: '#475569', marginBottom: 6 }}>Description</label>
                    <textarea rows={2} value={chapterForm.chapter_description} onChange={e => setChapterForm(f => ({ ...f, chapter_description: e.target.value }))} className={ta} />
                  </div>
                  <div style={{ gridColumn: 'span 2' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#475569', cursor: 'pointer' }}>
                      <input type="checkbox" checked={chapterForm.is_published} onChange={e => setChapterForm(f => ({ ...f, is_published: e.target.checked }))} />
                      Published
                    </label>
                  </div>
                </div>
              </div>
              <div style={{
                padding: '14px 24px', borderTop: '1px solid #e2e8f0', background: '#f8fafc',
                borderRadius: '0 0 20px 20px', display: 'flex', justifyContent: 'flex-end', gap: 12,
              }}>
                <button onClick={() => { setShowChapterForm(false); setEditingChapter(null); setChapterForm(EMPTY_CHAPTER); }}
                  style={{ padding: '9px 18px', borderRadius: 11, border: '1px solid #e2e8f0', background: 'white', color: '#64748b', fontSize: 13, cursor: 'pointer' }}>
                  Cancel
                </button>
                <button onClick={handleSaveChapter} disabled={savingChapter}
                  style={{ padding: '9px 22px', borderRadius: 11, background: savingChapter ? '#94a3b8' : C.orange, color: 'white', fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer' }}>
                  {savingChapter ? 'Saving...' : editingChapter ? 'Update' : 'Save Chapter'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
}

export default LawModule;